import { EmptyState } from '@dealstack/frontend/shared/components/EmptyState/EmptyState';
import { Button, Flex, FlexProps } from '@mantine/core';
import { generatePath, Link } from 'react-router-dom';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import React from 'react';
import styled from 'styled-components';
import { useTranslationCapChart } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { DEAL_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { PermissionWrapper } from '@dealstack/frontend/shared/components/PermissionWrapper/PermissionWrapper.tsx';
import {
	PermissionRole,
	ResourceType,
} from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions.ts';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams.ts';

export const CapChartEmptyState = () => {
	const { dealId } = useRequiredParams();
	const tCapChart = useTranslationCapChart();
	return (
		<StyledEmptyStateContainer justify="center">
			<EmptyState
				icon="es-pyramid"
				title={tCapChart('empty_state.title')}
				description={tCapChart('empty_state.description')}
			>
				<PermissionWrapper
					resourceType={ResourceType.DEAL}
					resourceId={dealId}
					permissionRole={PermissionRole.EDITOR}
				>
					<Link to={generatePath(`..${DEAL_ROUTES.PEOPLE}`, { personId: '' })}>
						<Button
							variant="default"
							rightSection={<Icon variant="arrow-right" size="lg" />}
						>
							{tCapChart('empty_state.button.set_up_cap')}
						</Button>
					</Link>
				</PermissionWrapper>
			</EmptyState>
		</StyledEmptyStateContainer>
	);
};

const StyledEmptyStateContainer = styled(Flex)<FlexProps>`
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 10;
`;
